

export class TemperatureOutputWithStatus implements ITemperatureOutputWithStatus {
    /** The auto-generated id of the temperature master */
    selected_temperature_id!: number;
    /** The voltage from */
    voltage_from!: number;
    /** The voltage to */
    voltage_to!: number;
    /** The temperature */
    temperature!: string;
    /** Manage status of fuel calibration. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ITemperatureOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected_temperature_id = _data["selected_temperature_id"];
            this.voltage_from = _data["voltage_from"];
            this.voltage_to = _data["voltage_to"];
            this.temperature = _data["temperature"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TemperatureOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected_temperature_id"] = this.selected_temperature_id;
        data["voltage_from"] = this.voltage_from;
        data["voltage_to"] = this.voltage_to;
        data["temperature"] = this.temperature;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITemperatureOutputWithStatus {
    /** The auto-generated id of the temperature master */
    selected_temperature_id: number;
    /** The voltage from */
    voltage_from: number;
    /** The voltage to */
    voltage_to: number;
    /** The temperature */
    temperature: string;
    /** Manage status of fuel calibration. 0 For De-active, 1 For Active */
    status: number;
}

